import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs'

import { AlertService } from './alert.service'
import { GeneralService } from './general.service'
import { RestClientService } from './rest.service'
import { ToastService } from './toast.service'

@Injectable()
export class In2SubscriptionService extends RestClientService {
    httproot = 'in2Subscription/'

    constructor(
        private generalService: GeneralService,
        private dialog: MatDialog,
        alertService: AlertService,
        http: HttpClient,
        private toastService: ToastService
    ) {
        super(http)
    }

    getOdooCustomer(): Observable<any> {
        return this.get<any>(this.httproot + 'getOdooCustomer/', {
            timeoutInSeconds: 60
        })
    }
    getOdooCustomerTransactions(): Observable<any> {
        return this.get<any>(this.httproot + 'getOdooCustomerTransactions/', {
            timeoutInSeconds: 60
        })
    }
    getOdooCustomerTransactionLines(): Observable<any> {
        return this.get<any>(
            this.httproot + 'getOdooCustomerTransactionLines/',
            { timeoutInSeconds: 60 }
        )
    }
    getOdooCustomerSubscriptions(): Observable<any> {
        return this.get<any>(this.httproot + 'getOdooCustomerSubscriptions/', {
            timeoutInSeconds: 60
        })
    }
    subscribeToAutomaticPayment(): Observable<any> {
        return this.get<any>(this.httproot + 'subscribeToAutomaticPayment', {
            timeoutInSeconds: 60
        })
    }
    payBalanceWithLink(): Observable<any> {
        return this.get<any>(this.httproot + 'payBalanceWithLink', {
            timeoutInSeconds: 60
        })
    }
    cancelSubscription(): Observable<any> {
        return this.get<any>(this.httproot + 'cancelSubscription', {
            timeoutInSeconds: 60
        })
    }
    reactivateCurrentSubscription(): Observable<any> {
        return this.get<any>(this.httproot + 'reactivateCurrentSubscription', {
            timeoutInSeconds: 60
        })
    }

    uploadBankTransferProof(fileData: any): Observable<any> {
        return this.post<any>(
            this.httproot + 'uploadBankTransferProof',
            fileData,
            { timeoutInSeconds: 60 }
        )
    }

    updatePaymentMethod(): Observable<any> {
        return this.get<any>(this.httproot + 'updatePaymentMethod', {
            timeoutInSeconds: 60
        })
    }

    getCustomerPaymentMethods(): Observable<any> {
        return this.get<any>(this.httproot + 'getCustomerPaymentMethods', {
            timeoutInSeconds: 60
        })
    }

    updateCustomerIn2SubscriptionPaymentMethod(idPaymentMethod: string) {
        return this.post<any>(
            this.httproot + 'updateCustomerIn2SubscriptionPaymentMethod',
            { value: idPaymentMethod },
            { timeoutInSeconds: 60 }
        )
    }

    getOdooTransactionLines(invoiceId_moveId: number) {
        return this.get<any>(
            this.httproot + 'getOdooTransactionLines/' + invoiceId_moveId,
            { timeoutInSeconds: 60 }
        )
    }

    deletePaymentMethod(idPaymentMethod:String) {
        return this.post<any>(this.httproot + 'deletePaymentMethod', {value: idPaymentMethod}, {timeoutInSeconds: 60});
    }


}
